import { useEffect, useState } from "react";
import { motion } from "framer-motion";

const links = [
  { id: "detaylar", label: "Davet" },
  { id: "geri-sayim", label: "Geri Sayım" },
  { id: "mekan", label: "Mekân" },
  { id: "mesaj", label: "Mesaj" },
];

const scrollTo = (id) => {
  const el = document.getElementById(id);
  if (!el) return;
  if (window.__lenis) window.__lenis.scrollTo(el, { offset: -8 });
  else el.scrollIntoView({ behavior: "smooth", block: "start" });
};

export const Nav = () => {
  const [scrolled, setScrolled] = useState(false);

  useEffect(() => {
    const onScroll = () => setScrolled(window.scrollY > 60);
    window.addEventListener("scroll", onScroll);
    return () => window.removeEventListener("scroll", onScroll);
  }, []);

  return (
    <motion.header
      data-testid="site-nav"
      initial={{ y: -80, opacity: 0 }}
      animate={{ y: 0, opacity: 1 }}
      transition={{ duration: 1, delay: 2.4, ease: [0.16, 1, 0.3, 1] }}
      className={`fixed inset-x-0 top-0 z-50 transition-colors duration-500 ${
        scrolled ? "bg-ink/70 backdrop-blur-xl border-b border-line/60" : "bg-transparent"
      }`}
    >
      <div className="mx-auto flex max-w-7xl items-center justify-between px-6 py-4 md:px-10">
        <button
          data-testid="nav-logo"
          onClick={() => window.scrollTo({ top: 0, behavior: "smooth" })}
          className="font-serif text-xl tracking-tight text-cream"
        >
          N <span className="italic text-gold">&</span> E
        </button>
        <nav className="hidden items-center gap-8 md:flex">
          {links.map((l) => (
            <button
              key={l.id}
              data-testid={`nav-${l.id}-link`}
              onClick={() => scrollTo(l.id)}
              className="group relative font-sans text-xs uppercase tracking-[0.25em] text-sand transition-colors hover:text-cream"
            >
              {l.label}
              <span className="absolute -bottom-1 left-0 h-px w-0 bg-gold transition-all duration-300 group-hover:w-full" />
            </button>
          ))}
        </nav>
        <button
          data-testid="nav-rsvp-cta"
          onClick={() => scrollTo("mesaj")}
          className="rounded-full border border-gold/50 px-5 py-2 font-sans text-xs uppercase tracking-[0.2em] text-gold transition-all duration-300 hover:bg-gold hover:text-ink"
        >
          Mesaj Bırak
        </button>
      </div>
    </motion.header>
  );
};
